// The keyboard shortcut overlay, opened with `?` anywhere outside a text field.
import { Modal } from "../ui/bits";

export const SHORTCUTS: readonly [string, string][] = [
  ["/", "Focus search"],
  ["?", "Show this list"],
  ["Esc", "Close a dialog or dropdown"],
  ["g t", "Go to Today"],
  ["g s", "Go to Settings"],
  ["g b", "Switch branch"],
  ["Shift+L", "Lock the screen"],
];

export function ShortcutsOverlay({ onClose }: { onClose: () => void }) {
  return (
    <Modal title="Keyboard shortcuts" meta="press ? anywhere" onClose={onClose} footer={<button className="btn" type="button" onClick={onClose}>Close</button>}>
      <dl className="kv shortcuts">
        {SHORTCUTS.map(([k, v]) => (
          <ShortcutRow key={k} k={k} v={v} />
        ))}
      </dl>
      <div className="help">Prescription entry completes without a mouse; every shortcut here stays out of the way of text fields.</div>
    </Modal>
  );
}

function ShortcutRow({ k, v }: { k: string; v: string }) {
  return <><dt>{k.split(" ").map((part, i) => <kbd key={i} style={{ marginRight: 4 }}>{part}</kbd>)}</dt><dd>{v}</dd></>;
}
